import React, { useState, useEffect } from 'react';
import { Card, Collapse, Row, Col, Select, Input, Button, Flex, Image } from 'antd';
import axios from '../util/axiosConfig';
import LineItemEditTable from './Tables/LineItemEditTable';
import '../styles/reports.css';
import ViewUpload from './ViewUpload';
import AuditLog from '../pages/auditLog';
import invoiceImage from '../assets/images/invoiceGRNicon.svg';

const { Option } = Select;

const SingleInvoiceEdit: React.FC = () => {
    const [panelData, setPanelData] = useState<any>(null);
    const [disputeReasons, setDisputeReasons] = useState<string[]>([]);
    const [isEditable, setIsEditable] = useState(false);
    const [isShowRemarks, setIsShowRemarks] = useState(false);
    const [selectedDisputeReason, setSelectedDisputeReason] = useState<number | undefined>(undefined);
    const [invoiceData, setInvoiceData] = useState<any>({});
    const [viewAuditlog, setViewAuditlog] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const data = Object.fromEntries(urlParams.entries());
        setPanelData(data);
    }, []);

    const fetchInvoiceData = async (id: number) => {
        try {
            const response = await axios.get(`/get-invoice-dto`, {
                params: {
                    invoiceId: id
                },
            });
            if (response?.data) {
                setInvoiceData(response?.data?.data);
                setSelectedDisputeReason(response?.data?.data?.disputeReasonId);
            }
        } catch (error) {
            console.error('Failed to fetch invoice data:', error);
        }
    };

    useEffect(() => {
        const fetchDisputeReasons = async () => {
            try {
                const response = await axios.get('/dispute-reason/list');
                if (response?.data?.data) {
                    setDisputeReasons(response.data.data);
                }
            } catch (error) {
                console.error('Failed to fetch dispute reasons:', error);
            }
        };

        if (panelData?.id) {
            fetchInvoiceData(panelData.id);
        }
        fetchDisputeReasons();
        // eslint-disable-next-line
    }, [panelData?.id]);

    const handleDisputeReasonChange = (value: any) => {
        if (value === 1 || value === 2 || value === 4 || value === 5) {
            setIsEditable(true);
            setIsShowRemarks(false);
        } else if (value === 3) {
            setIsEditable(false);
            setIsShowRemarks(true);
        } else {
            setIsEditable(false);
            setIsShowRemarks(false);
        }
        setSelectedDisputeReason(value);
    };

    const resetDisputeReason = async (finalRemarks: any) => {
        try {
            const payload = {
                invoicePageableDto: {
                    id: panelData?.id || 0,
                    reference: invoiceData.reference || '',
                    subject: invoiceData.subject || '',
                    invoiceReference: invoiceData.invoiceReference || '',
                    companyReference: invoiceData.companyReference || '',
                    currencyCode: invoiceData.currencyCode || '',
                    cfPostingDate: invoiceData.cfPostingDate || '',
                    invoiceDate: invoiceData.invoiceDate || '',
                    billingAddressReference: invoiceData.billingAddressReference || '',
                    subTotal: invoiceData.subTotal || 0,
                    poDate: invoiceData.poDate || '',
                    poNumber: invoiceData.poNumber || '',
                    status: invoiceData.status || '',
                    vendorName: invoiceData.vendorName || '',
                    taxableValue: invoiceData.taxableValue || 0,
                    taxAmount: parseFloat(invoiceData.taxAmount) || 0,
                    totalAmount: parseFloat(invoiceData.totalAmount) || 0,
                    fileDetailsId: invoiceData.fileDetailsId || 0,
                    s3Url: invoiceData.s3Url || '',
                    rejectionRemark: finalRemarks || invoiceData.rejectionRemark || '',
                    vendorUploadDtos: invoiceData?.vendorUploadDtos || []            
                },
                lineItemPageableDtos: []
            };

            await axios.post('/update-invoice', payload);
            if (panelData?.id) {
                fetchInvoiceData(panelData.id);
            }
        } catch (error) {
            console.error('Failed to update invoice:', error);
        }

        setSelectedDisputeReason(undefined);
        handleDisputeReasonChange(null);
    };

    const modificationLogroute = () => {
        setViewAuditlog(true);
    }
    const renderPanelHeader = () => (
        <>
            <Row>
                <Col span={24} className='align-center-div'>
                    <Row className="header-list-row" style={{ width: '100%' }}>
                    <Col span={7}>
                        <Row>
                            <Col span={3}>
                            <Image src={invoiceImage} alt="invoiceImage" className="invoiceLogo" preview={false} />
                            </Col>
                            <Col span={17}><p className='invoiceName'>{invoiceData?.invoiceReference || '-'}</p>
                            <p className='vendorName'>Vendor: {invoiceData?.vendorName || '-'}</p>
                            </Col>
                           
                        </Row>
                    </Col>
                        <Col span={3}>
                            <p className='invoiceLabels'>PO No:</p>
                            <p className='invoiceTxtvalue'>{invoiceData?.poNumber || '-'}</p>
                        </Col>
                        <Col span={2}>
                            <p className='invoiceLabels'>Tax Amount:</p>
                            <p className='invoiceTxtvalue'>{invoiceData?.taxAmount || '-'}</p>
                        </Col>
                        <Col span={3}>
                            <p className='invoiceLabels'>Total Amount:</p>
                            <p className='invoiceTxtvalue'>{invoiceData?.totalAmount || '-'}</p>
                        </Col>
                        <Col span={4}>
                        <p className='invoiceLabels'>Status:</p>
                        {/* <p className={typeof invoiceData?.status === 'string' && invoiceData?.status.toLowerCase().startsWith('success') ? 'greenStatus' : invoiceData?.status === '' ? 'blueStatus' : 'redStatus' } > */}
                        <p 
                            className={typeof invoiceData?.status === 'string' && invoiceData?.status?.toLowerCase().startsWith('success') && invoiceData?.status.toLowerCase().includes('cancelled')
                                ? 'orangeStatus'
                                : invoiceData?.status?.toLowerCase().startsWith('success')
                                  ? 'greenStatus'
                                  : invoiceData?.status === ''
                                    ? 'blueStatus'
                                    : 'redStatus'
                            } >
                            {invoiceData?.status ? invoiceData?.status : "Send to SAP"}
                        </p>
                    </Col>
                        <Col span={3}>
                            <p className='invoiceLabels'>Dispute Reason:</p>
                            <Select
                                placeholder="Select a reason"
                                onChange={handleDisputeReasonChange}
                                value={selectedDisputeReason}
                                style={{ width: '100%' }}
                                disabled={true}
                            >
                                {disputeReasons.map((reason: any) => (
                                    <Option key={reason?.id} value={reason?.id}>
                                        {reason?.name}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {isShowRemarks && (
                <Row>
                    <Col span={24}>
                        {/* Additional UI for remarks, if required */}
                    </Col>
                </Row>
            )}
            {invoiceData?.vendorUploadDtos?.length > 0 && (
                <Row>
                    <Col span={24}>
                        <Flex align='center' justify='flex-start'>
                            <ViewUpload fileList={invoiceData?.vendorUploadDtos} />
                        </Flex>
                    </Col>
                </Row>
            )}
        </>
    );

    return (
        <Card bordered={false} title={'View - Invoice'}>
            {!viewAuditlog && 
                <Button className='modLog' onClick={modificationLogroute}>Modification Log</Button>
            }
            <Collapse
                activeKey={panelData?.id}
                bordered={false}
                accordion={true}
                className='mt-2 single-edit-collapse'
            >
                <Collapse.Panel
                    header={renderPanelHeader()}
                    key={panelData?.id}
                >
                    <div>
                        <LineItemEditTable
                            panelID={panelData?.id}
                            rejectionRemark={invoiceData.rejectionRemark}
                            isEdit={isEditable}
                            isRemarks={isShowRemarks}
                            disputeReasonID={selectedDisputeReason}
                            isLineItemChange={resetDisputeReason}
                            isSuccess={invoiceData?.status?.toLowerCase().startsWith('success')}
                        />
                    </div>
                </Collapse.Panel>
            </Collapse>
            { viewAuditlog &&
                <div className='auditLogSection'>
                    <AuditLog></AuditLog>
                </div>
            }
        </Card>
    );
};

export default SingleInvoiceEdit;
